const clients = [
  {
    name: 'Terra Drone',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/n9gzcon3_Logo-Terra-Drone_Logo-Normal-Complete-1-1024x1024.png',
  },
  {
    name: 'PG JYX',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/fbz1mn92_PG%20JYX%20logo.png',
  },
  {
    name: 'Amazing Secret',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/jo1zupy2_AS%20logo.png',
  },
  {
    name: 'Terra Drone',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/n9gzcon3_Logo-Terra-Drone_Logo-Normal-Complete-1-1024x1024.png',
  },
  {
    name: 'PG JYX',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/fbz1mn92_PG%20JYX%20logo.png',
  },
  {
    name: 'Amazing Secret',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/jo1zupy2_AS%20logo.png',
  },
];

export default function MarqueeSection() {
  return (
    <section
      id="marquee"
      data-testid="marquee-section"
      className="py-12 bg-[#0D1321] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <p className="text-center text-white/50 text-xs tracking-[0.2em] uppercase font-semibold mb-8">
          Trusted by Leading Organisations
        </p>
      </div>

      {/* Marquee Container */}
      <div className="relative overflow-hidden">
        <div className="flex marquee-track">
          {/* First set of logos */}
          {clients.map((client, index) => (
            <div
              key={`first-${index}`}
              className="flex-shrink-0 mx-12 flex items-center justify-center"
            >
              <img
                src={client.logo}
                alt={client.name}
                loading="lazy"
                decoding="async"
                className="h-16 w-auto grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
          {/* Duplicate for seamless loop */}
          {clients.map((client, index) => (
            <div
              key={`second-${index}`}
              className="flex-shrink-0 mx-12 flex items-center justify-center"
            >
              <img
                src={client.logo}
                alt={client.name}
                loading="lazy"
                decoding="async"
                className="h-16 w-auto grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
